import { render, staticRenderFns } from "./description-column.vue?vue&type=template&id=3f651ff4"
import script from "./description-column.vue?vue&type=script&lang=js"
export * from "./description-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports